import React, { useContext, useMemo, useState } from 'react';

import { ChildrenPropType } from '../../../../prop-types/children';
import { noop } from 'ui-components/default-props/noop';

const WalletRegistrationErrorContext = React.createContext({
  errors: [],
  setErrors: noop,
});
export const useWalletRegistrationErrorContext = () => useContext(WalletRegistrationErrorContext);

export const WalletRegistrationErrorContextProvider = ({ children }) => {
  const [validationErrors, setValidationErrors] = useState();
  const [errors, setErrors] = useState([]);
  const [showAllErrors, setShowAllErrors] = useState(false);

  const value = useMemo(
    () => ({
      validationErrors,
      setValidationErrors,
      errors,
      setErrors,
      showAllErrors,
      setShowAllErrors,
    }),
    [validationErrors, setValidationErrors, errors, setErrors, showAllErrors, setShowAllErrors],
  );

  return <WalletRegistrationErrorContext.Provider value={value}>{children}</WalletRegistrationErrorContext.Provider>;
};

WalletRegistrationErrorContextProvider.propTypes = {
  children: ChildrenPropType.isRequired,
};
